import { CompLocationCore } from '../core/location/comp'

export const CompLocation = CompLocationCore
